/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'preview': {
    width: 48,
    height: 48,
    viewBox: '0 0 48 48',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M22 6.66C13.528 6.66 6.66 13.529 6.66 22S13.529 37.34 22 37.34 37.34 30.471 37.34 22 30.471 6.66 22 6.66zM1 22C1 10.402 10.402 1 22 1s21 9.402 21 21-9.402 21-21 21S1 33.598 1 22z" _fill="#000"/><path pid="1" fill-rule="evenodd" clip-rule="evenodd" d="M32.8 32.8a2.732 2.732 0 0 1 3.864 0l9.536 9.536a2.732 2.732 0 0 1-3.864 3.864L32.8 36.664a2.732 2.732 0 0 1 0-3.864zM22 12c1.657 0 3 1.248 3 2.788v13.424C25 29.752 23.657 31 22 31s-3-1.248-3-2.788V14.788C19 13.248 20.343 12 22 12z" _fill="#000"/><path pid="2" fill-rule="evenodd" clip-rule="evenodd" d="M12 22c0-1.657 1.248-3 2.788-3h13.424C29.752 19 31 20.343 31 22s-1.248 3-2.788 3H14.788C13.248 25 12 23.657 12 22z" _fill="#000"/>'
  }
})
